import React, {useMemo, useState} from "react";
import useCustomTable from "../tables/useCustomTable";
import {Block, Title} from "../components";
import Table from "../tables/Table";
import {ExpanderCell} from "../tables/ExpanderCell";
import {OsIcon} from "../OsIcon";
import {useHistory} from "react-router-dom";
import {Badge, Button} from "react-bootstrap";
import Icon from "../Icon";
import {AppGroupModal} from "./AppGroupModal";
import {useTranslation} from "react-i18next";

export default function CmpApps({setAppPreviewId, createAppGroup, publisherId, ...props}) {
  const { t } = useTranslation();
  const history = useHistory();
  const [showAppGroupModal, setShowAppGroupModal] = useState(false)

  const apps = useMemo(()=>{
    return [props.apps.appGroups?.map(row => {
      const {apps, ...otherElements} = row
      return {...otherElements, subRows: apps}
    }), props.apps.apps].flat().filter(element => {
      return element != undefined;
    })
  }, [props.apps])

  const columns = [{
    id: 'expander',
    Cell: ExpanderCell,
    maxWidth: 2,
    minWidth: 2,
  },{
    Header: 'Os',
    accessor: 'os',
    width: 30,
    Cell: ({row}) => (<OsIcon os={row.original.os} style={{fontSize: "2em"}} />),
  },{
    Header: 'Name',
    accessor: 'name',
    Cell: ({row}) => (<>
      {row.original.type == 'app_group' && <><Badge variant={"primary"}>{t(`cmp.appGroup`)}</Badge> </>}
        {row.original.name || row.original.bundleId}
      </>),
    // Cell: ({row}) => (row.original.name || row.original.bundleId),
    width: 500,
  }, {
    Header: 'Bundle ID',
    accessor: 'bundleId',
  },{
    id: 'preview',
    Header: '',
    width: 50,
    Cell: ({row}) => row.original.type != 'app_group' && <Button variant={"primary"} onClick={(e) => {
      e.stopPropagation()
      setAppPreviewId(row.original.id)
    }}>Preview</Button>
  }];

  const tableOptions = {
    sortable: false,
    paginate: false,
    filterable: false,
    autoWidth: false
  };

  const {
    tableProps
  } = useCustomTable(tableOptions)

  const showNewAppGroupModal = () => {
    setShowAppGroupModal(true)
  }

  const onCreate = (data) => {
    createAppGroup({publisherId, appGroup: data}).unwrap().then((data) => {
      setShowAppGroupModal(false)
    })
  }

  return <>
    <Title group={false}>
      {createAppGroup && <Button onClick={showNewAppGroupModal}><Icon icon={"plus"}/>{t("cmp.apps.addAppGroup")}</Button>}
    </Title>
    <Block>
      <Table
        data={apps}
        columns={columns}
        onRowClick={(data) => history.push(`/${data.type.split('_').map(el => el+'s').join('/')}/${data.id}/cmp/configuration`)}
        {...tableProps} />
    </Block>
    <AppGroupModal show={showAppGroupModal}
                   setShow={setShowAppGroupModal}
                   editable={true}
                   onCreate={onCreate}/>
  </>
}
